import { Empty, Skeleton } from "antd-mobile";
import Item5 from "./Item5";
import { useNewsListCtrl } from "./hooks/useNewsList";
import { Fragment } from "react/jsx-runtime";
import { useNewsAdCpt as useAdCpt } from "@/hooks/adCpt/pageAds";

export default function NewsList() {
  const { loadingNewsList, isEmptyNewsList, resData } = useNewsListCtrl();
  return (
    <div className="pt-16 mb-20">
      <div data-position="position-41" className="mb-16">
        {useAdCpt("position-41")}
      </div>

      {loadingNewsList ? (
        <div className="px-16 pb-16">
          <Skeleton.Paragraph lineCount={10} className="newsList-loading" animated />
        </div>
      ) : isEmptyNewsList ? (
        <div className="center">
          <Empty className="py-150" imageStyle={{ width: 128 }} description="暂无数据" />
        </div>
      ) : (
        resData.map((it: any, idx: any) => {
          return (
            <Fragment key={idx}>
              <Item5 arr={it} />
              {idx != resData.length - 1 && (
                <div data-position="position-42" className="mb-10">
                  {useAdCpt("position-42")}
                </div>
              )}
            </Fragment>
          );
        })
      )}
    </div>
  );
}
